export function formatWithSpaces(number: number, locale = 'en-US') {
  return new Intl.NumberFormat(locale, { style: 'decimal', useGrouping: true }).format(number).replace(/,/g, '\u00A0');
}
